import laroute from '../../vendor/laroute'

class Laroute {
    install (Vue, options) {
        Vue.prototype.$laroute = laroute

        Vue.component('laroute-link', require('./components/laroute-link').default)
    }
}

export default new Laroute()
